import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { Provider } from "react-redux";

import { store } from "./store/store";
import { toast } from "react-toastify";
import { setForbiddenHandler, setUnauthorizedHandler } from "./api/client";
import { logout } from "./store/slices/authSlice";

// Expired or logged-out session: clear it and go to the login page once
setUnauthorizedHandler(() => {
  if (!store.getState().auth.accessToken) return;
  store.dispatch(logout());
  const { pathname, search } = window.location;
  if (pathname !== "/login")
    window.location.replace(
      `/login?returnUrl=${encodeURIComponent(pathname + search)}`,
    );
});

// No access for this role: one toast per message (blob bodies have no message, so a generic one)
setForbiddenHandler((error) => {
  const data = error?.response?.data;
  const raw = data && !(data instanceof Blob) ? data.message : null;
  const message =
    (Array.isArray(raw) ? raw.join(" ") : raw) ||
    "Your role has no access to this.";
  toast.error(message, { toastId: `forbidden:${message}` });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
